export const getDeviceFlag = (flags, { key }) => {
  return flags[key];
};
